import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { UI } from "@/data/i18n/ui";

export const LANGS = [["es", "ES", "Español"], ["en", "EN", "English"], ["pt", "PT", "Português"]];
const KEY = "mutoni-lang";
const Ctx = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

const initial = () => {
  const saved = typeof window !== "undefined" ? window.localStorage.getItem(KEY) : null;
  return LANGS.some(([k]) => k === saved) ? saved : "es";
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(initial);
  useEffect(() => {
    window.localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((k, vars) => {
    let s = UI[lang]?.[k] ?? UI.es[k] ?? k;
    if (vars) Object.entries(vars).forEach(([n, v]) => { s = s.replaceAll(`{${n}}`, v); });
    return s;
  }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useLang = () => useContext(Ctx);

/** Merge a translation map entry ({ en: { id: {...} } }) over a Spanish source object. */
export const locById = (obj, map, lang) => (lang === "es" || !obj ? obj : { ...obj, ...(map?.[lang]?.[obj.id] ?? {}) });

/** Merge AI translations stored on backend docs (doc.i18n.en / doc.i18n.pt). */
export const locDoc = (doc, lang) => (lang === "es" || !doc?.i18n?.[lang] ? doc : { ...doc, ...doc.i18n[lang] });
